import { render, staticRenderFns } from "./Vue2LeafletHotline.vue?vue&type=template&id=7b60ef1b"
import script from "./Vue2LeafletHotline.vue?vue&type=script&lang=js"
export * from "./Vue2LeafletHotline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports